import { observer } from 'mobx-react';
import { FC, ReactElement, memo, useEffect } from 'react';
import { IMealItemEditModal } from './types/mealItemEditModal';
import { mealItemEditModalStore } from './store/mealItemEditModalStore';
import { MealItemEditModalForm } from './containers/MealItemEditModalForm/MealItemEditModalForm';
import { MealItemEditModalFooter } from './containers/MealItemEditModalFooter/MealItemEditModalFooter';
import { localeStore } from 'src/mobx/localesStore';
import CustomModalComponent from 'src/view/components/Controls/Modal/Modal';
import ModalBackground from 'src/view/components/Controls/Modal/ModalBackground/ModalBackground';
import ModalHeader from 'src/view/components/Controls/Modal/ModalHeader/ModalHeader';
import '../MealSizeEditModal/style.scss';

export const MealItemEditModal: FC<IMealItemEditModal> = memo(
  observer((props: IMealItemEditModal): ReactElement => {
    useEffect(() => {
      mealItemEditModalStore.initStore(props);
    }, []);

    return (
      <CustomModalComponent isOpen className="meal-edit-modal" onRequestClose={mealItemEditModalStore.onCloseModal} withCloseIcon>
        <ModalBackground>
          <ModalHeader title={localeStore.t(mealItemEditModalStore.modalHeader)} />
          <MealItemEditModalForm />
          <MealItemEditModalFooter />
        </ModalBackground>
      </CustomModalComponent>
    );
  })
);
